"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.function.name");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vue = _interopRequireDefault(require("vue"));

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var BreadcrumbComponent = /*#__PURE__*/function (_Vue) {
  (0, _inherits2.default)(BreadcrumbComponent, _Vue);

  var _super = _createSuper(BreadcrumbComponent);

  function BreadcrumbComponent() {
    (0, _classCallCheck2.default)(this, BreadcrumbComponent);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(BreadcrumbComponent, [{
    key: "homeRoute",
    get: function get() {
      return this.$isAdmin ? '/admin-dashboard' : '/dashboard';
    }
  }, {
    key: "breadcrumbList",
    get: function get() {
      var _this = this;

      return this.$breadcrumbList.map(function (dataval) {
        return {
          'text': _this.$t("navigation.".concat(dataval['name'])),
          'href': dataval['name'] === 'dashboard' ? _this.$isAdmin ? '#/admin-dashboard' : '#/dashboard' : dataval['link'] || '#',
          'active': dataval['link'] ? true : false
        };
      });
    }
  }]);
  return BreadcrumbComponent;
}(_vue.default);

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isAdmin', {
  namespace: 'authentication'
})], BreadcrumbComponent.prototype, "$isAdmin", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('breadcrumbList', {
  namespace: 'common'
})], BreadcrumbComponent.prototype, "$breadcrumbList", void 0);
BreadcrumbComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'BreadcrumbComponent',
  components: {
    'el-breadcrumb': _elementUi.Breadcrumb,
    'el-breadcrumb-item': _elementUi.BreadcrumbItem
  }
})], BreadcrumbComponent);
var _default = BreadcrumbComponent;
exports.default = _default;